export const GET_PAYMENT_OPTIONS_OVERVIEW = 'GET_PAYMENT_OPTIONS_OVERVIEW'

export const GET_PAYMENT_OPTIONS = 'GET_PAYMENT_OPTIONS'
export const POST_PAYMENT_OPTIONS = 'POST_PAYMENT_OPTIONS'
export const RESET_FORM_OPTIONS = 'RESET_FORM_OPTIONS'

export const GET_STRIPE_PAYMENT_STATUS = 'GET_STRIPE_PAYMENT_STATUS'
